import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "@/components/feature/Logo";

const NAV_LINKS = [
  { to: "/", label: "首页", match: "/" },
  { to: "/category/movie", label: "电影", match: "/category/movie" },
  { to: "/category/tv", label: "电视剧", match: "/category/tv" },
  { to: "/category/variety", label: "综艺", match: "/category/variety" },
  { to: "/search", label: "搜索", match: "/search" },
  { to: "/about", label: "关于", match: "/about" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const isActive = (match: string) => {
    if (match === "/") return location.pathname === "/";
    return location.pathname.startsWith(match);
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-background-200"
          : "bg-background-50/60 backdrop-blur-sm border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 h-16 flex items-center gap-4 md:gap-6">
        <Logo />

        <nav className="hidden md:flex items-center gap-1 flex-1">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3.5 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                isActive(link.match)
                  ? "text-primary-500 bg-primary-50"
                  : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="hidden md:flex items-center gap-2 ml-auto w-56 lg:w-72 h-10 px-3 rounded-full bg-background-100 border border-background-200 focus-within:border-primary-400 transition-colors"
        >
          <i className="ri-search-line text-foreground-500 text-base"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索电影、电视剧、综艺"
            name="q"
            className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 outline-none"
          />
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 bg-background-100 cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 flex flex-col gap-3">
          <form
            onSubmit={handleSearch}
            className="flex items-center gap-2 w-full h-10 px-3 rounded-full bg-background-100 border border-background-200"
          >
            <i className="ri-search-line text-foreground-500 text-base"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视内容"
              name="q"
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 outline-none"
            />
          </form>
          <div className="grid grid-cols-2 gap-2">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(link.match)
                    ? "text-primary-500 bg-primary-50"
                    : "text-foreground-600 bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}